import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeTimelineItem'
 * @name TypeTimelineItemFields
 * @type {TypeTimelineItemFields}
 * @memberof TypeTimelineItem
 */
export interface TypeTimelineItemFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized false
     */
    header: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'description' (Description)
     * @name Description
     * @localized false
     */
    description: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'icon' (Icon)
     * @name Icon
     * @localized false
     */
    icon: EntryFieldTypes.Symbol;
}

/**
 * Entry skeleton type definition for content type 'timelineItem' (Timeline Item)
 * @name TypeTimelineItemSkeleton
 * @type {TypeTimelineItemSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-23T21:14:30.625Z
 * @version 27
 */
export type TypeTimelineItemSkeleton = EntrySkeletonType<TypeTimelineItemFields, "timelineItem">;
/**
 * Entry type definition for content type 'timelineItem' (Timeline Item)
 * @name TypeTimelineItem
 * @type {TypeTimelineItem}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-23T21:14:30.625Z
 * @version 27
 */
export type TypeTimelineItem<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeTimelineItemSkeleton, Modifiers, Locales>;

export function isTypeTimelineItem<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeTimelineItem<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'timelineItem'
}
